import Layout from "../components/Layout";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import React, {useEffect, useState,useRef} from "react";
import axios from "axios";
import {BASE_URL} from "../utils/commonUrl";
import {useSelector} from "react-redux";
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import QuarterNames from "../components/QuarterNames";
import { confirm } from "react-bootstrap-confirmation";
import { toast } from 'react-toastify'

const PromotionRecommendationForHR = () => {
    const primeToast = useRef(null);
    const [start] = useState(0);
    const [empIdpList, setEmpIdpList] = useState([]);
    const {user} = useSelector((state) => state["auth"]);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');    
    const [quarterName, setQuarterName] = useState("");
    const [confirmResult, setConfirmResult] = useState();

    const successNotify = (message) => toast.info(message);
    const errorNotify = (message) => toast.error(message);

    useEffect(() => {
        initFilters();        
        getEmployeeIDPList(user.registerID,user.quarterID)
        setQuarterName(user.quarterName);
    }, [])


    const getEmployeeIDPList = (registerID,quarterID) => {         
        const _dbModel={registerId:registerID,quarterId: parseInt(quarterID)}
            axios.post(BASE_URL + "/api/employeepromotion/GetEmployeePromotionListForHR/" ,JSON.stringify(_dbModel))
                .then(response => {   
                    console.log(response.data);                     
                    setEmpIdpList(response.data)
                })
                .catch(e => console.log(e))
    }
    

const savePromotionRecommendation =async(registerID,quarterID,recommendationStatus) => { 
    const hrCommentModel = empIdpList.filter((item) => Number(item.registerID) === registerID)
    console.log(registerID);
    console.log(quarterID);
    console.log(hrCommentModel[0].hrComment); 
    const _dbModel={registerId:registerID,quarterId: parseInt(quarterID),recommendationStatus: parseInt(recommendationStatus),recommenderRegisterID: parseInt(user.registerID),addedBy: user.registerID.toString(),hrComment: hrCommentModel[0].hrComment}
       await axios.post(BASE_URL + "/api/employeepromotion/SavePromotionRecommendationForHR/" ,JSON.stringify(_dbModel))
            .then(response => {                            
                if (response.status === 200) {                    
                    successNotify("Data saved successfully.");   
                    getEmployeeIDPList(user.registerID,user.quarterID)                
                }
            })
            .catch(e => console.log(e))
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }


    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
        });
        setGlobalFilterValue('');
    }
    const clearFilter = () => {
        initFilters();
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                               placeholder="Keyword Search"/>
                </span>
                </div>
            </div>
        </div>
    );

    const childToParent = () => {
        var e = document.getElementById("ddlQuarter");
        var _selectedValue = e.value==="-1"?user.quarterID:e.value;
        setQuarterName(e.value==="-1"?user.quarterName:e.options[e.selectedIndex].text); 
        getEmployeeIDPList(user.registerID,_selectedValue);       
      }

      const onCommentChange = (registerID, e) => {
        const comments = e.currentTarget.value;
        //const unsetOpinion = tableData.filter(item => Number(item.sl) === sl)
        empIdpList.forEach(taskList => {
            if (taskList.registerID === registerID) {
                taskList.hrComment = comments;                
            }
        });       
    }

      function Table({ tableData }) {
        return (
            <table className="table" rows={10} paginator>
                <thead>
                    <tr>
                        <th>SL.</th>
                        <th >RegisterID</th>
                        <th>Emp Code</th>
                        <th >Employee Name</th>
                        <th >Department</th>
                        <th >Designation</th>
                        <th >Supervisor Recommendation Status</th>
                        <th >Supervisor Name</th>
                        <th >HOD Recommendation Status</th>
                        <th >HOD Name</th>
                        <th >Division Head Recommendation Status</th>  
                        <th >HR Recommendation Status</th>  
                        <th className="text-center">Remarks</th>
                        <th className="text-center">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {tableData.map((data, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}</td>
                                <td >{data.registerID}</td>
                                <td>{data.employeeCode}</td>
                                <td>{data.employeeName}</td>
                                <td>{data.department}</td>
                                <td>{data.designation}</td>
                                <td>{data.recommendationStatusDetail}</td>
                                <td>{data.supervisorName}</td>
                                <td>{data.hodRecommendationStatusDetail}</td>
                                <td>{data.hodName}</td>
                                <td>{data.divisionHeadRecommendationStatusDetail}</td> 
                                <td style={{fontWeight:"bold"}}>{data.hrRecommendationStatusDetail}</td>  
                                <td className="text-center">                                 
                                  <textarea defaultValue={data.hrComment}
                                  onChange={(e) => onCommentChange(data.registerID, e)}
                                  ></textarea>
                                </td>
                                <td className="text-center">
                                    <input
                                        type="submit"
                                        onClick={() => savePromotionRecommendation(data.registerID,data.quarterID,1)}
                                        className="btn btn-success"
                                        value="Save" />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        );
    }
    


    return (<Layout>

        <div className="card mt-2">
            <div className="card-header d-flex justify-content-between">
                <h6><i class="bi bi-person-check"></i> Employee List</h6>
                 <h4> <QuarterNames childToParent={childToParent} hidden={true}/></h4> 
            </div>
            <div className="card-body" style={{overflow:'scroll'}}>                
            <Table tableData={empIdpList} />
            </div>
        </div>

    </Layout>)

}


export default PromotionRecommendationForHR